import { render } from "./AddInteraction.vue?vue&type=template&id=1a0d1858&scoped=true"
import script from "./AddInteraction.vue?vue&type=script&lang=js"
export * from "./AddInteraction.vue?vue&type=script&lang=js"

import "./AddInteraction.vue?vue&type=style&index=0&id=1a0d1858&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0d1858"]])

export default __exports__